import { LocalStorage } from 'helpers/localStorage';

export type ABTestStorageValue = { name: string };

export const ABTestingStore = (experiment: string) =>
  new LocalStorage<ABTestStorageValue, null>(experiment, null);
